import { FunctionComponent } from 'react';
import styles from './NoData.module.scss';

type FC = FunctionComponent;

const NoData: FC = () => (
  <div className={styles.container}>
    <div className={styles['bg-container']} />
    <div className={styles['no-data-text']}>
      <h3>No Data Found</h3>
      <p>Transaction data will update in real-time</p>
    </div>
  </div>
);

export default NoData;
